module.exports = __webpack_public_path__ + "static/why-video-bg-min-d6a79a8f81f8d5bc2ecaf1f107c34012.png";